module.exports = __webpack_public_path__ + "assets/img/ic-reply.a98774d6.svg";